export default "__VITE_ASSET__BAPen76z__"